import { Card, Stack, Text } from '@mantine/core'
import { useGetMeasurementsByDevice } from 'api/measurements/getMeasurementsByDevice'
import Datatable from 'components/datatable'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import { RiPencilRuler2Line } from 'react-icons/ri'
import { useParams, useSearchParams } from 'react-router-dom'
import { TMeasurementList } from 'shared/types'
import { capitalizeFirstLetter } from 'shared/utils'
import { QueryPaginated, TDatatable } from '..'
import { DeviceMeasurementsFilters } from './DeviceMeasurementsFilters'
import { ExportMeasurementsToCSVButton } from './ExportMeasurementsToCSVButton'

const headers: (
  t: TFunction,
) => TDatatable<TMeasurementList['items'][number]>[] = t => [
  {
    id: 'date',
    label: t('generic.date'),
    colSize: 1,
    selector: (item, { dayjs }) => (
      <Text>{dayjs(item.date).format('DD.MM.YYYY, HH:mm')}</Text>
    ),
  },
  {
    id: 'value',
    label: t('generic.value'),
    colSize: 1,
    selector: item => (
      <Text>
        {item.value} {item.unit!.symbol}
      </Text>
    ),
  },
  {
    id: 'indicator',
    label: capitalizeFirstLetter(t('sensor.indicator')),
    colSize: 1,
    selector: item => (
      <Text>
        {item?.indicator?.isExternal
          ? item?.indicator?.name || '-'
          : t(`indicator.${item.indicator!.code}`) || '-'}
      </Text>
    ),
  },
]

export const DeviceMeasurementList = () => {
  const { t } = useTranslation()
  const { deviceId } = useParams()
  const [urlParams] = useSearchParams()
  const query = useGetMeasurementsByDevice(deviceId)

  return (
    <Card>
      <Stack>
        <DeviceMeasurementsFilters
          noWrapper
          excludeDevice
          exportButton={
            <ExportMeasurementsToCSVButton
              deviceId={deviceId!}
              indicatorCode={urlParams.get('indicatorCode') || undefined}
              dateFrom={urlParams.get('dateFrom') || undefined}
              dateTo={urlParams.get('dateTo') || undefined}
            />
          }
        />
        <QueryPaginated.Wrapper query={query}>
          <QueryPaginated.Data>
            {(data: TMeasurementList) => (
              <Datatable noShadow headers={headers(t)} data={data.items} />
            )}
          </QueryPaginated.Data>
          <QueryPaginated.NoData
            icon={RiPencilRuler2Line}
            title={t('measurement.noData')}
          />
        </QueryPaginated.Wrapper>
      </Stack>
    </Card>
  )
}
